import React from 'react';
import {
  AppBar, AppBarProps, Box, Toolbar,
} from '@mui/material';

type ActionBarProps = {
  children: React.ReactNode,
  endAdornment: React.ReactNode
  sx?: AppBarProps['sx']
};

const ActionBar = ({
  children,
  endAdornment,
  sx = {},
}: ActionBarProps) => (
  <AppBar
    position="sticky"
    sx={sx}
  >
    <Toolbar
      variant="dense"
      sx={{
        minHeight: 52,
      }}
    >
      <Box
        display="flex"
        width="100%"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {children}

        {endAdornment}
      </Box>
    </Toolbar>
  </AppBar>
);

export default ActionBar;
